"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINK_COLOR_BY_TYPE = void 0;
exports.Panel = Panel;
exports.PanelStyledMarkup = PanelStyledMarkup;
const jsx_runtime_1 = require("react/jsx-runtime");
const colors_1 = require("../styling/colors");
const bind_1 = __importDefault(require("classnames/bind"));
const panel_m_scss_1 = __importDefault(require("./panel.m.scss"));
const cx = bind_1.default.bind(panel_m_scss_1.default);
const PANEL_COLORS_BY_TYPE = {
    info: {
        textColor: 'basic-gray87',
        panelColor: 'basic-gray4',
    },
    error: {
        textColor: 'basic-white',
        panelColor: 'additional-deep-red',
    },
    success: {
        textColor: 'basic-white',
        panelColor: 'additional-teal',
    },
    warning: {
        textColor: 'basic-gray87',
        panelColor: 'additional-yellow',
    },
};
exports.LINK_COLOR_BY_TYPE = {
    info: 'basic-blue',
    error: 'basic-white',
    success: 'basic-white',
    warning: 'basic-gray87',
};
/**
 * Информационная панель. Обычно используется для выводя важной информации которую нужно выделить.
 * @param props Свойства.
 * @return Элемент.
 */
function Panel({ type = 'info', adornmentStart, adornmentEnd, className, style, children, 'data-testid': testId = 'panel', }) {
    const textColor = PANEL_COLORS_BY_TYPE[type].textColor;
    const panelColor = PANEL_COLORS_BY_TYPE[type].panelColor;
    return ((0, jsx_runtime_1.jsxs)("div", { className: cx('root', `type-${type}`, (0, colors_1.bgColor)(panelColor), (0, colors_1.color)(textColor), className), "data-testid": testId, style: style, children: [adornmentStart && (0, jsx_runtime_1.jsx)("div", { className: cx('adornment'), children: adornmentStart }), (0, jsx_runtime_1.jsx)("div", { className: cx('main'), children: children }), adornmentEnd && (0, jsx_runtime_1.jsx)("div", { className: cx('adornment'), children: adornmentEnd })] }));
}
/**
 * Блок стилизующий неизвестную html-верстку по дизайн-гайдам Panel.
 * @param props Свойства.
 * @return Элемент.
 */
function PanelStyledMarkup({ markup }) {
    return (0, jsx_runtime_1.jsx)("div", { className: cx('unknown-content'), dangerouslySetInnerHTML: { __html: markup } });
}
Panel.UnknownContent = PanelStyledMarkup;
//# sourceMappingURL=panel.js.map